import { render, staticRenderFns } from "./NkChart1.vue?vue&type=template&id=2e847e5f&scoped=true"
import script from "./NkChart1.vue?vue&type=script&lang=js"
export * from "./NkChart1.vue?vue&type=script&lang=js"
import style0 from "./NkChart1.vue?vue&type=style&index=0&id=2e847e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e847e5f",
  null
  
)

export default component.exports